<template>
  <div class="diy-special dis-flex flex-y-center">
  <!-- 图片 -->
  <form bindsubmit="_onTargetIndex" report-submit="true">
    <button formType="submit" class="btn-normal dis-flex">
      <div class="special-left">
        <img style="width:100%" :src="itemStyle.img">
      </div>
    </button>
  </form>
  <!-- 资讯轮播 -->
  <van-swipe :class="'special-content flex-box display_'+itemStyle.display" :autoplay="2200" :duration="800"  :display-multiple-items="itemStyle.display" :show-indicators="false">
    <van-swipe-item v-for="(item,index) in datalist" :key="index">
      <form bindsubmit="_onTargetDetail" report-submit="true">
        <button formType="submit" class="btn-normal dis-flex" :data-id="item.article_id">
          <div class="content-item onelist-hidden">
            <p>{{ item.article_title }}</p>
          </div>
        </button>
      </form>
    </van-swipe-item>
  </van-swipe>
  <!-- 更多资讯 -->
  <form bindsubmit="_onTargetIndex" report-submit="true">
    <button formType="submit" class="btn-normal dis-flex">
      <div class="special-more">
        <i class="iconfont icon-xiangyoujiantou"/>
      </div>
    </button>
  </form>
</div>
</template>

<script>
import { Swipe, SwipeItem } from 'vant';
import Vue from "vue";
Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "params","datalist"],
  created(){

  },
  activated() {
  },
  methods:{
    _onTargetDetail(e) {
      // 记录formid
      // this.router.push({
      //   path:''
      // })

      // wx.navigateTo({
      //   url: '/pages/article/detail/index?article_id=' + e.detail.target.dataset.id
      // });
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* 头条快报 */

.diy-special .special-left {
  padding: 5px 10px;
}

.diy-special .special-left img {
  display: block;
  width: 70px;
}

.diy-special .special-content {
  /* width: 500rpx; */
  overflow: hidden;
}

.diy-special .special-content .content-item {
  padding: 2px 0;
  font-size: 13px;
  color: #141414;
  /* height: auto; */
}

.diy-special .special-content.display_1 {
  height: 22px;
}

.diy-special .special-content.display_2 {
  height: 44px;
}

.diy-special .special-more {
  padding: 12px 10px;
  font-size: 12px;
}

</style>